import React from "react";
import { Button } from "@mui/material";

export const SecondaryButton = ({ onClick, children }) => (
  <Button
    sx={{ borderRadius: "15px", textTransform: "none" }}
    onClick={onClick}
  >
    {children}
  </Button>
);
